import { Controller } from '@hotwired/stimulus'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default class extends Controller {
  static targets = ['field']

  async connect() {
    try {
      const fp = await FingerprintJS.load()
      const result = await fp.get()
      this.fieldTarget.value = result.visitorId
    } catch (e) {
      // Fingerprinting failed — leave field empty, server will still use phone for dedup
      console.warn('Fingerprint unavailable:', e)
    }
  }
}
